import {Divider, Paper} from '@material-ui/core';
import AWDLoginForm from 'ApplicationEntry/components/AWDLoginForm';
import {matchAWDLogin} from 'ApplicationEntry/models/AWDLogin';
import AllstateBenefitsLogo from 'Core/assets/images/AllstateBenefitsLogo.png';
import React from 'react';
import {useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import Loading from 'Shared/components/Loading';
import './AWDLogin.sass';

const AWDLogin = () => {
  const {awdLogin} = useSelector((state: ReducerState) => state);

  return (
    <div className="awd-login">
      <Paper className="awd-login__paper">
        <div className="awd-login__header">
          <img src={AllstateBenefitsLogo} className="header__logo" alt="Allstate Benefits Logo" />
          <Divider className="header__vertical-divider" orientation="vertical" />
          <h2 className="header__title">App Entry</h2>
        </div>
        {matchAWDLogin(awdLogin, {
          UnsuccessfulAWDLogin: login => <AWDLoginForm awdLogin={login} />,
          InvalidAWDLogin: login => <AWDLoginForm awdLogin={login} />,
          ValidAWDLogin: login => <AWDLoginForm awdLogin={login} />,
          UnvalidatedAWDLogin: login => <AWDLoginForm awdLogin={login} />,
          ValidatingAWDLogin: () => (
            <div className="awd-login__loading-container">
              <Loading />
            </div>
          ),
        })}
      </Paper>
    </div>
  );
};

export default AWDLogin;
